import emma from '@/common/services/Emma'

const SubscriptionsResource = {
	postSubscription (subscription) { return emma.post('api/subscription', subscription) },
	updateSubscription (id, subscription) { return emma.post('api/subscription/' + id, subscription) },
	cancelSubscription (id) { return emma.post('api/subscription/' + id + '/cancel') },
	getSubscriptions () { return emma.get('api/subscription') },
	getSubscription (id) { return emma.get('api/subscription/' + id) },
	confirmPayment (data) { return emma.post('api/subscription/confirm-payment', data) }
}

export default SubscriptionsResource



// WEBPACK FOOTER //
// ./src/common/resources/Subscriptions.js